import { getPlanningWeekMode } from "../../util/localStorage.service";
import { MOBILE_QUERY } from "../../util/useMediaQuery";

export const DAY_MODE = "day";
export const MULTI_DAY_MODE = "multi";

/**
 * Mode of the weekly planning: the user's last choice, else "Jour" on phones and several days on larger screens.
 */
export const planningWeekMode = (savedMode, isMobile) => savedMode || (isMobile ? DAY_MODE : MULTI_DAY_MODE);

/**
 * The mode the page will show, for the route loader (which runs before the page).
 */
export const currentPlanningWeekMode = () => planningWeekMode(
  getPlanningWeekMode(),
  window.matchMedia(MOBILE_QUERY).matches
);
